import { Formik } from "formik";
import { Divider, Grid, TextField, FormLabel, Select, MenuItem , Autocomplete} from "@mui/material";
import { useEffect, useState } from "react";
import { Modal } from "../../../components/common/Modal/Modal";
import { ModalHeader } from "../../../components/common/Modal/ModalHeader";
import { ModalBody } from "../../../components/common/Modal/ModalBody";
import { ModalFooter } from "../../../components/common/Modal/ModalFooter";
import { useStoreStore } from "../../../hooks/useStoreStore";
import { useBranchOfficeStore } from "../../../hooks/useBranchOfficeStore";
import { useProductClassificationStore } from "../../../hooks/useProductClassificationStore";

type Values = {
    id: number,
    name: string,
    idbranchoffice:number,
    status: string,
}

export const ProductClassificationModal: React.FC<any> = (props): JSX.Element | any => {

    const { open, closeModal, classificationSelected, listclassification, clearState } = props;

    const { action, createProductClassification, editProductClassification } = useProductClassificationStore();
    const { getBranchOffice } = useBranchOfficeStore();

    const [loading, setLoading] = useState(false);
    const [loadingdata, setLoadingdata] = useState(false);
    const [branchOffices, setBranchOffices] = useState<any>([]);
    const [branchOfficeSelected, setBranchOfficeSelected] = useState<any>('');
    const [data, setData] = useState<Values>({
        id: classificationSelected ? classificationSelected.id :'',
        name: classificationSelected ? classificationSelected.name :'',
        idbranchoffice: classificationSelected ? classificationSelected.idbranchoffice :'',
        status: classificationSelected ? classificationSelected.status :'1',
    });

    useEffect(() => {
        getBranchOfficeApi()
    },[])

    useEffect(() => {
        if(classificationSelected && branchOffices){
            setCustomBranchOffice(classificationSelected.idbranchoffice, branchOffices)
        }
    },[classificationSelected, branchOffices])

    const setCustomBranchOffice = (idbranchoffice, branchOffices) => {
        const data = branchOffices.find(branch => branch.id == idbranchoffice);
        return setBranchOfficeSelected(data);
    }

    const getBranchOfficeApi = async(search='') => {
        try {
            setLoadingdata(true);
            const response = await getBranchOffice(search);
            if(!response){
                setBranchOffices([]);
                setLoadingdata(false);
                return false;
            }else{
                setBranchOffices(response || []);
                setLoadingdata(false);
            }
        } catch (error) {
            setLoadingdata(false);
        }
    }

    const validateForm = (values) => {
        let errors:any = {};
        if(!values.name) errors.name = "el campo es requerido";
        if(!values.idbranchoffice) errors.idbranchoffice = "el campo es requerido";
        return errors;
    }

    const onSubmit = async(values)  => {
        setLoading(true);

        if(classificationSelected){
            const response:any = await editProductClassification(classificationSelected.id, values);
            if(response){
                listclassification && listclassification();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }else{
            const response:any = await createProductClassification(values);
            if(response){
                listclassification && listclassification();
                closeModal && closeModal();
                clearState && clearState();
                setLoading(false);
            }else{
                setLoading(false);
                return false;
            }
        }
    }

    return (
        <Modal open={open} handleClose={closeModal} disableEscapeKeyDown disableBackdropClick handle size="md" paperprops={{style: { position: 'absolute', right: -30, borderRadius: 20, animation: 'slide-in 0.3s ease-out', maxHeight: '100%', height: '100vh' }}}>
            <ModalHeader
                text={
                    action == 'edit' ? 'Editar Clasificación' : (action == 'add' ? 'Nueva Clasificación' : 'Detalle de la Clasificación')
                }
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Grid container sx={{padding:'20px'}}>
                                    <Grid item container xs={12} spacing={2}>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Nombre:</FormLabel>
                                            <TextField
                                                id="name"
                                                type="text" 
                                                name="name"
                                                fullWidth
                                                size="small"
                                                value={values.name}
                                                onChange={handleChange}
                                                error={errors.name && touched.name ? true : false}
                                                helperText={errors.name && touched.name ? errors.name : ''}
                                                inputProps={{ readOnly: action == 'detail' }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <FormLabel>Sucursal:</FormLabel>
                                            <Autocomplete
                                                id="idbranchoffice"
                                                size="small"
                                                value={!!branchOfficeSelected ? branchOfficeSelected : null}
                                                options={branchOffices || []}
                                                loading={loadingdata}
                                                getOptionLabel={(option) => option?.name || ''}
                                                isOptionEqualToValue={(option,value)=> option.name === value?.name} 
                                                renderInput={(params) => 
                                                    <TextField {...params} label="" size="small" 
                                                        error={errors.idbranchoffice && touched.idbranchoffice ? true : false}
                                                        helperText={errors.idbranchoffice && touched.idbranchoffice ? errors.idbranchoffice : ''}
                                                    />
                                                }
                                                onChange={(e, newValue: any) => {
                                                    setBranchOfficeSelected(newValue)
                                                    setFieldValue('idbranchoffice', newValue ? newValue.id : "");
                                                }}
                                                readOnly={action == 'detail'}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Divider />
                                {
                                    action != 'detail' && (
                                        <ModalFooter 
                                            buttonType="submit"
                                            confirmText={'Guardar'}
                                            onConfirm={handleSubmit}
                                            cancelText={"Cancelar"}
                                            onCancel={closeModal}
                                            loadingConfirmText={loading}
                                            clearState={clearState}
                                        />
                                    )
                                }
                                
                            </form>
                        )
                    }} 
                </Formik>
            </ModalBody>
        </Modal>
    )
}